// import React from "react";
import { Button, Col, Input, Row, Select, Tooltip, Form, Typography, Modal, message, Card, Empty, Upload, Dropdown, Spin } from "antd";
import React, { useState, useEffect, useRef } from "react";
import axiosClient from "../../Authentication/ApiCall";
import authService from "../../Authentication/authService";
import ClipLoader from "react-spinners/ClipLoader";
import { UserOutlined, EditOutlined, DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import _, { } from "lodash";

const FloorOnboarding = () => {
  const { Text } = Typography;
  const [modal, setModal] = useState(false);
  const [form] = Form.useForm();
  const [editform] = Form.useForm();
  const [AddRefresh, setAddRefresh] = useState(1);
  const [Pageload, setPageload] = useState(false);
  const [tabledata, settabledata] = useState([]);
  const [editrecord, seteditrecord] = useState(null);
  const [editModal, seteditModal] = useState(false);
  const [Stores, setStores] = useState([]);
  const [svgPreview, setSvgPreview] = useState(null);
  const [coordinates, setCoordinates] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ x: 0, y: 0 });
  const [selectedOption, setSelectedOption] = useState(null);;
  const [uploaded, setUploaded] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [Cameras, setCameras] = useState([]);
  const [overlayLabels, setOverlayLabels] = useState([]);
  const [loading, setLoading] = useState(true);
  const { Option } = Select;

  const handleUpload = (file) => {
    setUploaded(true)
    setCoordinates([])
    handleUploadCameraOption(editrecord.id)
    const reader = new FileReader();
    reader.onload = (e) => {
      setSvgPreview((e.target.result.toString("binary")).toString("base64"))
    };
    reader.readAsDataURL(file);
    setDropdownVisible(false)
    return false;
  };

  const onclickmodal = () => {
    setDropdownVisible(false)
    setCoordinates([])
    setOverlayLabels([])
    setModal(true);
    form.resetFields();
  };

  const handlecreateeventclose = () => {
    setModal(false);
    form.resetFields();
  };

  const onFinish = (values) => {
    axiosClient
      .post("/flooronboard/addflooronboarddetails", {
        storeId: values.store,
        floorName: values.floorname.toUpperCase(),
        floorImage: values.floorImage === undefined ? null : values.floorImage,
        cameraLocations: null
      })
      .then((response) => {
        if (response.data.issuccess === true) {
          message.success(response.data.data);
          setAddRefresh(AddRefresh + 1);
          setModal(false);
          form.resetFields();
        }
      })
      .catch((err) => {
        setModal(false);
        setPageload(false);
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });
  };

  const onEditRecord = (items) => {
    setCoordinates([])
    setOverlayLabels([])
    setDropdownVisible(false)
    getFloorImagedetails(items)
    seteditModal(true);
    setUploaded(false);
    setFileList([])
    setSvgPreview(null)
    editform.setFieldsValue({
      storeName: items.storeName,
      floorName: items.floorName,
    });
  };

  const handleclose = () => {
    // setCoordinates([])
    // setOverlayLabels([])
    // setDropdownVisible(false)
    seteditModal(false)
    // setFileList([])
    // setSvgPreview(null)
  };

  const onFinishedit = (values) => {
    setLoading(true)
    var filtered_coordinates = coordinates.filter((item) => item.cameraId !== null)
    setCoordinates(filtered_coordinates);
    axiosClient
      .put("/flooronboard/editflooronboarddetails", {
        id: editrecord.id,
        storeId: editrecord.storeId,
        currentfloorName: editrecord.floorName,
        newfloorName: values.floorName,
        floorImage: svgPreview == null ? null : svgPreview,
        cameraLocations: filtered_coordinates,
      })
      .then((response) => {
        setLoading(false)
        if (response.status === 200) {
          // setPageload(false)
          seteditModal(false);
          setAddRefresh(AddRefresh + 1);
          message.success(response.data.msg);
        } else {
          setPageload(false);
          message.error(response.data.msg);
        }
      })
      .catch((err) => {
        setLoading(false)
        seteditModal(false);
        // setPageload(false)
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });

    form.resetFields();
  };

  const onDeleteRecord = (items) => {
    Modal.confirm({
      title: (
        <div>
          <h3>Confirm Delete?</h3>
          <h4>
            {" "}
            The Floor Details will be deleted
          </h4>
        </div>
      ),
      okText: "Confirm",
      okType: "danger",
      onOk: () => {
        axiosClient
          .get("/flooronboard/deleteflooronboarddetails?id=" + items.id)
          .then((response) => {
            if (response.data.issuccess === true) {
              message.success(response.data.msg);
              setAddRefresh(AddRefresh + 1);
            } else {
            }
          })
          .catch((err) => {
            if (err.status === 0) {
              message.error("Server error");
            } else {
              message.error(err.msg);
            }
          });
      },
    });
    form.resetFields();
  };

  const oncancelofform = () => {
    setModal(false);
    form.resetFields();
  };

  const handleSvgClick = (event) => {
    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    var cameracoordinatevalue = [];
    cameracoordinatevalue.push({ x: x, y: y, cameraId: null });
    cameracoordinatevalue = cameracoordinatevalue.concat(coordinates);
    setCoordinates(cameracoordinatevalue)
    setDropdownVisible(true);
    setDropdownPosition({ x: event.clientX, y: event.clientY });
  };

  const handleRemove = (file) => {
    setCoordinates([])
    setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));
    setUploaded(false);
    setSvgPreview(null)
  };

  const handleFileChange = ({ file, fileList: updatedFileList }) => {
    setFileList(updatedFileList);
    if (updatedFileList.length > 0) {
      setUploaded(true);
    } else {
      setUploaded(false);
    }
  };

  const handleOptionChange = (value) => {
    const selectedCamera = Cameras.find((camera) => camera.id === value);
    setOverlayLabels((prev) => [
      ...prev,
      {
        x: dropdownPosition.x - 95,
        y: dropdownPosition.y - 150,
        cameraName: selectedCamera.cameraName,
      },
    ]);
    setCameras(Cameras.filter(camera => camera.id !== value))
    setCoordinates((prevArr) => {
      const updatedArr = [...prevArr];
      updatedArr[0] = { ...updatedArr[0], cameraId: value };
      return updatedArr;
    });
    setSelectedOption(value);
    setDropdownVisible(false);
    setSelectedOption(null);
  };

  const handleUploadCameraOption = (floorid) => {
    axiosClient
      .get(`/flooronboard/getcameradetails?id=${floorid}`)
      .then((response) => {
        if (response.data.issuccess === true) {
          setCameras(response.data.data);
          setOverlayLabels([])
        }
        else {
          message.warning(response.data.msg);
        }
      })
      .catch((err) => {
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });
  }

  const handleEditCameraOption = (cameraids, floorid, editcoordinates) => {
    axiosClient
      .get(`/flooronboard/getcameradetails?id=${floorid}`)
      .then((response) => {
        if (response.data.issuccess === true) {
          setCameras(response.data.data.filter((num) => !cameraids.includes(num.id)));
          const updatedCoordinates = editcoordinates.map((coord) => {
            const camera = response.data.data.find((camera) => camera.id === coord.cameraId);
            return {
              ...coord,
              x: coord.x - 50 ,
              y: coord.y - 10,
              cameraName: camera ? camera.cameraName : null
            };
          });
          setOverlayLabels(updatedCoordinates)
        }
        else {
          message.warning(response.data.msg);
        }
      })
      .catch((err) => {
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });
  }

  const getFloorImagedetails = (items) => {
    setLoading(true)
    axiosClient
      .get(
        `/flooronboard/getfloorimagedetails?id=${items.id}`
      )
      .then((response) => {
        if (response.data.issuccess === true) {
          setLoading(false)
          if (response.data.data.floorImage != null) {
            setCoordinates(response.data.data.cameraLocations)
            setSvgPreview(response.data.data.floorImage)
            handleEditCameraOption(response.data.data.cameraLocations.map((item) => parseInt(item.cameraId)), items.id, response.data.data.cameraLocations)           
          }
          else {
            setDropdownVisible(false)
          }
        }
      })
      .catch((err) => {
        setLoading(false)
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });
  }

  useEffect(() => {
    axiosClient
      .get("/flooronboard/getstoredetails")
      .then((response) => {
        if (response.data.issuccess === true) {
          setStores(response.data.data);
        }
      })
      .catch((err) => {
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });
  }, []);

  useEffect(() => {
    axiosClient
      .get("/flooronboard/getflooronboarddetails")
      .then((response) => {
        if (response.data.issuccess === true) {
          settabledata(response.data.data);
        }
      })
      .catch((err) => {
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });
  }, [AddRefresh]);

  return (
    <>
      <div
        className="report-content"
        style={{
          // height: "120px",
          backgroundColor: "#000816",
          width: "100%",
          // marginLeft: "9px",
          margin: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* First Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginLeft: "3%",
            padding: "10px",
            marginTop: "10px",
          }}
        >
          <p
            style={{
              color: "white",
              fontSize: "21px",
              fontFamily: "revert-layer",
            }}
          >
            Floor Onboarding
          </p>
          <div style={{ display: "flex", marginRight: "3%" }}>
            <Button
              style={{ userSelect: "none" }}
              className="adduser"
              onClick={onclickmodal}
            >
              + New
            </Button>
          </div>
        </div>
      </div>


      <Modal
        className="onsubmitrtspmodal"
        destroyOnClose
        centered
        open={modal}
        onCancel={oncancelofform}
        title={
          <>
            <Row align={"middle"} justify={"center"}>
              <Col>
                <Text className="Modal-Header">Floor Onboarding</Text>
              </Col>
            </Row>
          </>
        }
        footer={
          <>
            <Row justify={"space-around"}>
              <Col>
                {authService.getCurrentUserReadOnly() ? (
                  <Tooltip title="you need permission to submit">
                    <Button type="primary" block disabled>
                      Submit
                    </Button>
                  </Tooltip>
                ) : (
                  <Button
                    className="primary-button"
                    form="submitAdduserForm"
                    type="primary"
                    block
                    htmlType="submit"
                  >
                    Submit
                  </Button>
                )}
              </Col>
              <Col>
                <Button onClick={() => handlecreateeventclose()}>Cancel</Button>
              </Col>
            </Row>
          </>
        }
      >
        <Row>
          <Col
            xs={{ span: 24, offset: 0 }}
            sm={{ span: 24, offset: 0 }}
            md={{ span: 24, offset: 0 }}
            lg={{ span: 24, offset: 0 }}
            xl={{ span: 24, offset: 0 }}
            xxl={{ span: 24, offset: 0 }}
          >
            {" "}
            <div style={{ marginTop: "20px" }}>
              <Form
                id="submitAdduserForm"
                // layout="vertical"
                form={form}
                name="basic"
                onFinish={onFinish}
                autoComplete={"off"}
                style={{ padding: "27px" }}
              >
                <Form.Item
                  labelCol={{
                    span: 9,
                  }}
                  wrapperCol={{
                    span: 10,
                  }}
                  label="Store"
                  name="store"
                  rules={[
                    {
                      required: true,
                      message: "Please Select Store!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: 200 }}
                    placeholder="Select a store"
                  >
                    {Stores.map((store) => (
                      <Option key={store.id} value={store.id}>
                        {store.storeName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  // className="top-space"
                  labelCol={{
                    span: 9,
                  }}
                  wrapperCol={{
                    span: 11,
                  }}
                  label="FloorName"
                  name="floorname"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the floor name!",
                    },
                  ]}
                >
                  <Input style={{ width: 200 }} />
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </Modal>

      {/* //loading modal */}
      <Modal
        className="LoadinModal"
        open={Pageload}
        style={{ background: "none", textAlign: "center" }}
        footer={false}
        closable={false}
        centered
      >
        <ClipLoader
          color="#23234d"
          loading={Pageload}
          cssOverride={{
            display: "block",
            margin: "0 auto",

            borderWidth: "5px",
            marginBottom: "10px",
          }}
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
          title="Loading..."
        />
        <Text style={{ color: "white", fontSize: "1.2em" }}>Loading ...</Text>
      </Modal>

      <Row
        gutter={[10, 10]}
        align={"middle"}
        justify={"center"}
        style={{ marginTop: "18px" }}
      >
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 24, offset: 0 }}
          md={{ span: 24, offset: 0 }}
          lg={{ span: 24, offset: 0 }}
          xl={{ span: 23, offset: 0 }}
          xxl={{ span: 23, offset: 0 }}
        >
          {tabledata.length > 0 ? (
            <Row gutter={[6, 6]}>
              {tabledata.map((items) => (
                <Col
                  xs={{ span: 14, offset: 0 }}
                  sm={{ span: 14, offset: 0 }}
                  md={{ span: 14, offset: 0 }}
                  lg={{ span: 14, offset: 0 }}
                  xl={{ span: 4, offset: 0 }}
                  xxl={{ span: 4, offset: 0 }}
                >
                  <Card
                    hoverable
                    title={items.storeName + ' - ' + items.floorName}
                    styles={{
                      title: { textAlign: "center" },
                      body: { padding: 0 },
                      height: "300px",
                    }}
                  >
                    <div
                      className="border-line"
                      style={{ borderBottom: "1px solid #d9d0d0" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "0 16px",
                        }}
                      >
                        <Button
                          type="text"
                          icon={<EditOutlined />}
                          onClick={() => {
                            onEditRecord(items);
                            seteditrecord(items);
                          }}
                        />

                        <Button
                          type="text"
                          icon={<DeleteOutlined style={{ color: "red" }} />}
                          // onClick={handleDelete}
                          onClick={() => {
                            onDeleteRecord(items);
                          }}
                        />
                      </div>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "230px",
              }}
            >
              <Empty />
            </div>
          )}
        </Col>
      </Row>

      <Modal
        title="Edit Record"
        onCancel={() => seteditModal(false)}
        centered
        open={editModal}
        width={1800}
        // height={500}
        footer={
          <>
            <Row justify={"space-around"}>
              <Col>
                {authService.getCurrentUserReadOnly() ? (
                  <Tooltip title="you need permission to submit">
                    <Button type="primary" block disabled>
                      Submit
                    </Button>
                  </Tooltip>
                ) : (
                  <Button
                    className="primary-button"
                    form="submiteditform"
                    type="primary"
                    block
                    htmlType="submit"
                  >
                    Submit
                  </Button>
                )}
              </Col>
              <Col>
                <Button onClick={() => handleclose()}>Cancel</Button>
              </Col>
            </Row>
          </>
        }
      // onCancel={handleCancel}
      >
        <Form
          form={editform}
          id="submiteditform"
          name="basic"
          onFinish={onFinishedit}
          autoComplete={"off"}

        >
          <Row gutter={24} >
            <Col span={8}>
              <Form.Item
                label="Store Name"
                name="storeName"

                rules={[
                  {
                    required: false,
                    message: "Please enter your Store Name!",
                  },
                ]}
              >
                <Input
                  placeholder="Store Name"
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  disabled={true}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Floor Name"
                name="floorName"
                rules={[
                  {
                    required: true,
                    message: "Please enter the floor!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Floor Image"
                name="floorimage"
                rules={[
                  {
                    required: false,
                    message: "Please upload the file!",
                  },
                ]}
              >
                <Upload
                
                  beforeUpload={handleUpload}
                  showUploadList={false}
                  fileList={fileList}
                  // onRemove={handleRemove}
                  onChange={handleFileChange}
                >
                  <Button disabled={uploaded} icon={<UploadOutlined />}>Click to Upload</Button>
                </Upload>
                <Button
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={handleRemove}
                />
              </Form.Item>
            </Col>
          </Row>


          {/* SVG Preview */}
          {svgPreview && (
            <Form.Item
            >
              <div
                style={{
                  width: "1650px",
                  height: "700px",
                  border: "1px solid #d9d9d9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={svgPreview}
                  alt="SVG Preview"
                  style={{
                    width: "1650px",
                    height: "700px",
                    cursor: "pointer",
                    position: "absolute",
                }}
                  onClick={handleSvgClick}
                />                            

                {overlayLabels.map((label, index) => (
                  <div
                    key={index}
                    style={{
                      position: "absolute",
                      top: label.y,
                      left: label.x,
                      background: "rgba(0, 0, 0, 0.5)",
                      color: "#fff",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      pointerEvents: "none",
                      zIndex: 600,
                    }}
                  >
                    {label.cameraName}
                  </div>
                ))}

                {dropdownVisible && (
                  <Select
                    value={selectedOption}
                    onChange={handleOptionChange}
                    placeholder="Select the camera"
                    style={{
                      position: "absolute",
                      top: (dropdownPosition?.y || 0) - 150, // 10px below the clicked point
                      left: (dropdownPosition?.x || 0) - 150, // 10px to the right of the clicked point
                      zIndex: 500,
                      width: "200px",
                    }}
                  >
                    {Cameras.map((camera) => (
                      <Option key={camera.id} value={camera.id}>
                        {camera.cameraName}
                      </Option>
                    ))}
                  </Select>
                )}

              </div>
            </Form.Item>
          )}

          {loading && (
            <Spin
              size="large"
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 999,
              }}
            />
          )}

        </Form>
      </Modal>

    </>
  );
};
export default FloorOnboarding;
